export function observeSentinel(controller, { rootMargin = "100px" } = {}) {
  disconnectObserver(controller);

  if (!controller.hasSentinelTarget) return;

  controller.observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) controller.loadMore();
      });
    },
    { rootMargin },
  );

  controller.observer.observe(controller.sentinelTarget);
}

export function disconnectObserver(controller) {
  if (controller.observer) {
    controller.observer.disconnect();
    controller.observer = null;
  }
}

export function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
}
